import React from "react";
import { MessageSquare, Sparkles, BookOpen, Calculator } from "lucide-react";
interface ChatWelcomeProps {
  onExampleClick: (question: string) => void;
}
export const ChatWelcome: React.FC<ChatWelcomeProps> = ({
  onExampleClick
}) => {
  const exampleQuestions = [{
    icon: Sparkles,
    text: "Explain quantum physics in simple terms",
    category: "Science"
  }, {
    icon: BookOpen,
    text: "Help me understand Shakespeare's Hamlet",
    category: "Literature"
  }, {
    icon: Calculator,
    text: "Solve this calculus problem step by step",
    category: "Mathematics"
  }, {
    icon: MessageSquare,
    text: "What are the causes of World War II?",
    category: "History"
  }];
  return <div className="flex h-full flex-col items-center justify-center px-4 py-12">
      
      
      <h1 className="mb-3 text-center text-3xl font-bold text-foreground">
        Start a conversation
      </h1>
      
      <p className="mb-8 max-w-md text-center text-muted-foreground">
        Ask me anything! I'm here to help you learn, explore ideas, and answer your questions.
      </p>

      <div className="w-full max-w-2xl">
        <p className="mb-4 text-center text-sm font-medium text-foreground">
          Try asking:
        </p>
        
        <div className="grid gap-3 sm:grid-cols-2">
          {exampleQuestions.map((example, index) => {
          const Icon = example.icon;
          return <button key={index} onClick={() => onExampleClick(example.text)} className="group flex items-start gap-3 rounded-xl border border-border bg-card p-4 text-left transition-all hover:border-primary/50 hover:bg-accent hover:shadow-md">
                
                <div className="flex-1 min-w-0">
                  <p className="mb-1 text-xs font-medium text-muted-foreground">
                    {example.category}
                  </p>
                  <p className="text-sm font-medium text-foreground group-hover:text-primary line-clamp-2">
                    {example.text}
                  </p>
                </div>
              </button>;
        })}
        </div>
      </div>
    </div>;
};